import React from "react";
import PMSHoldingsTable from "../../components/HoldingsTable/PMSHoldingsTable";
import HoldingsErrorDialog from "../../components/HoldingsTable/HoldingsErrorDialog";
import AppLoader from "../../components/AppLoader/AppLoader";
import { useUserHoldingsFetch } from "./useUserHoldingsFetch";

interface PMS {
  requestId: number;
  id: number;
  noteficationId: number;
  holdingName: string;
  category: string;
  investedAmount: number;
  currentAmount: number;
  transactionDate: string;
  currentNavDate: string;
  currentNAV: number;
  realisedPnL: number;
  transactions: [];
  xirr: string;
  days: number;
  unrealisedPnL: number;
  absolutePnL: string;
  type: string;
  folioNumber: string;
}

const PmsHoldings: React.FC = () => {
  const {
    loader,
    errorMessage,
    setErrorMessage,
    data: PMS,
    pageSize,
    totalPages,
    currentPage,
    handlePageChange,
    handlePageSizeChange,
    fetchHoldings,
  } = useUserHoldingsFetch<PMS>("PMS", "Failed to load PMS holdings.");

  return (
    <>
      <AppLoader loading={loader} />
      <PMSHoldingsTable
        data={PMS}
        totalPages={totalPages}
        currentPage={currentPage}
        pageSize={pageSize}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        fetchData={fetchHoldings}
      />
      <HoldingsErrorDialog
        open={Boolean(errorMessage)}
        message={errorMessage}
        title="Unable to load PMS holdings"
        onClose={() => setErrorMessage(null)}
      />
    </>
  );
};

export default PmsHoldings;
